<template>
  <div>
    <img v-if="params[field] !== null" class="battery" v-bind:src="icon"/>
    <span v-else >-- --</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      icon: null,
      batteryFull: require('../../../../assets/img/aggrid/battery-full.png'),
      batteryLow: require('../../../../assets/img/aggrid/battery-low.png'),
      batteryHalf: require('../../../../assets/img/aggrid/battery-half.png')
    }
  },
  props: ['params', 'field'],
  watch:{
    params(){
      this.getBatteryIcon(this.params[this.field]);
    }
  },
  created() { 
    this.getBatteryIcon(this.params[this.field]);
  },
  methods: {
    getBatteryIcon(id) {
      switch (id) {
        case 0:
          this.icon = this.batteryLow;
          break;
        case 1:
          this.icon = this.batteryFull;
          break;  
        case 2:
          this.icon = this.batteryHalf;
          break;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .battery{
    height: 11px;
    width: 20px;
  }
</style>